import { Directive, HostListener } from '@angular/core';

import { StepperComponent } from './stepper.component';

@Directive({
  selector: '[zcStepperNext]',
})
export class StepperNextDirective {
  constructor(private stepper: StepperComponent) {}

  @HostListener('click')
  onClick() {
    this.stepper.next();
  }
}
